import { Failure } from "@pdfking/errors"
import type { Validator } from "@pdfking/forms"
import type { ComponentFailure } from "@pdfking/imposition/internal"
import type { ImpositionSchema } from "@pdfking/imposition/internal"
import { ApplyComponentFailures } from "@pdfking/imposition/internal"

/**
 * Mirrors Python `clean_grow` (`packing/presets/base.py:113-128`): when
 * `on_top` limits the overlap to N pages, a book component's signatures may not
 * exceed N. Fails the offending component's `grow_kind`.
 */
export const ValidateBookSignatures: Validator<ImpositionSchema> = results => {
  if (results.component_array.error) return results

  // only the `tNN` on_top entries carry a page limit; `on`/`off` don't
  const pages = results.on_top.value?.pages
  if (!pages) return results

  const failures: ComponentFailure[] = []

  const components = results.component_array.value ?? []
  components.forEach(({ grow_kind: { is_book, sides_tuple, id } }, ci) => {
    if (is_book && sides_tuple && !sides_tuple.every(side => side <= pages)) {
      failures.push({
        path: [ci, "grow_kind"],
        error: Failure("SIGNATURE_TOO_LARGE_FOR_PAGES", {
          input: id,
          pages,
        }),
      })
    }
  })

  return ApplyComponentFailures(results, failures)
}
